<template>
  <div class="container">
    <v-tabs v-model="$store.state.adminPanel.tab" background-color="#F7F7F7" fixed-tabs>
      <v-tab href="#tab-1"> Database </v-tab>
      <v-tab href="#tab-2"> Graph</v-tab>
    </v-tabs>

    <v-tabs-items v-model="$store.state.adminPanel.tab">
      <v-tab-item :value="'tab-1'">
        <v-data-table :headers="manualDataHeaders" :items="data" :page.sync="page" :items-per-page="itemsPerPage" :loading="loading" hide-default-footer class="elevation-1" @page-count="pageCount = $event"></v-data-table>
        <div class="text-center pt-2">
          <v-pagination v-model="page" :length="pageCount"></v-pagination>
        </div>
      </v-tab-item>
      <v-tab-item :eager="true" :value="'tab-2'">
        <FrequencyGraph :eager="true" ref="freq"/>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import FrequencyGraph from "./FrequencyGraph.vue";
import * as d3 from "d3";
import FrequencyGraphVue from './FrequencyGraph.vue';

export default {
  name: "ManualResults",
  components: {
    FrequencyGraph,
  },
  mounted() {
  },
  data() {
    return {
      tab: 0,
      loading: true,
      page: 1,
      data: [],
      itemsPerPage: 10,
      pageCount: 0,
      manualDataHeaders: [
        {
          text: "User",
          align: "start",
          sortable: false,
          value: "user",
          width: "500px",
        },
        {
          text: "Time (days)",
          align: "start",
          value: "days",
        },
        {
          text: "Date",
          align: "start",
          value: "date",
        },
      ],
    };
  },
  mounted() {
  },
  methods: {
    
    updateData(data) {
      this.data = data;
      this.loading = false;

      this.$refs.freq.updateData(data)

    },
  },
};
</script>
